import React, { createContext } from 'react';

export const ServiceInImuebleTypeContext = createContext();